import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class NutzungsgradWaermeerzeugerWarmwasser extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    waermeerzeuger_warmwasser_id: number | null = null;
    installationsperiode_id: number | null = null;
    nutzungsgrad: number | null = null;

    // view fields:
    waermeerzeuger_warmwasser: string | null = null;
    waermeerzeuger_reihenfolge: number | null = null;
    installationsperiode: string | null = null;
    installationsperiode_reihenfolge: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'NutzungsgradWaermeerzeugerWarmwasser';
    }
}

export async function createNewNutzungsgradWaermeerzeugerWarmwasser(): Promise<NutzungsgradWaermeerzeugerWarmwasser> {
    const nutzungsgradwaermeerzeugerwarmwasser = createModel(NutzungsgradWaermeerzeugerWarmwasser, {});

    await nutzungsgradwaermeerzeugerwarmwasser.save();
    return nutzungsgradwaermeerzeugerwarmwasser;
}

export class NutzungsgradWaermeerzeugerWarmwasserCollection extends BaseCollection<NutzungsgradWaermeerzeugerWarmwasser> {
    protected modelCls = NutzungsgradWaermeerzeugerWarmwasser;

    public getModelClassName(): string {
        return 'NutzungsgradWaermeerzeugerWarmwasser';
    }
}
